module.exports = __webpack_public_path__ + "img/page-26.375f2d0b.jpg";